import React, { useEffect, useRef, useState } from 'react';

const Clock = ({ onlyJS = false }) => {
  const ImportedJSRef = useRef(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const importJS = async () => {
      try {
        const { default: namedImport } = await import(`./widget-v2`);
        ImportedJSRef.current = namedImport;
      } catch (err) {
        throw err;
      } finally {
        setLoading(false);
      }
    };
    importJS();
  }, []);

  useEffect(() => {
    if (!loading && ImportedJSRef.current) {
      const script = document.createElement('script');

      script.async = true;
      script.type = 'text/javascript';

      script.script = ImportedJSRef.current;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [loading, ImportedJSRef]);

  return onlyJS ? (
    <></>
  ) : (
    <div>
      <climate-clock id="climateclock"></climate-clock>
    </div>
  );
};

export default Clock;
